export default __webpack_public_path__ + "static/media/globalMenuIcon.ea5749a0.svg";